import { render } from "./AppBadge.vue?vue&type=template&id=1454f3f6"
import script from "./AppBadge.vue?vue&type=script&lang=js"
export * from "./AppBadge.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__